import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { setupAuthGuards } from './guards'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/DashboardLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: 'Dashboard', requiresAuth: true }
      },
      {
        path: '/associacoes',
        name: 'Associacoes',
        component: () => import('@/views/associacoes/AssociacoesList.vue'),
        meta: { title: 'Associações' }
      },
      {
        path: '/associacoes/nova',
        name: 'NovaAssociacao',
        component: () => import('@/views/associacoes/AssociacaoForm.vue'),
        meta: { title: 'Nova Associação' }
      },
      {
        path: '/associacoes/:id',
        name: 'EditarAssociacao',
        component: () => import('@/views/associacoes/AssociacaoForm.vue'),
        meta: { title: 'Editar Associação' }
      },
      {
        path: '/associacoes/:id/detalhes',
        name: 'DetalhesAssociacao',
        component: () => import('@/views/associacoes/AssociacaoDetalhes.vue'),
        meta: { title: 'Detalhes da Associação' }
      },
      {
        path: '/empresas',
        name: 'Empresas',
        component: () => import('@/views/empresas/EmpresasList.vue'),
        meta: { title: 'Empresas' }
      },
      {
        path: '/empresas/nova',
        name: 'NovaEmpresa',
        component: () => import('@/views/empresas/EmpresaForm.vue'),
        meta: { title: 'Nova Empresa' }
      },
      {
        path: '/empresas/:id',
        name: 'EditarEmpresa',
        component: () => import('@/views/empresas/EmpresaForm.vue'),
        meta: { title: 'Editar Empresa' }
      },
      {
        path: '/empresas/:id/detalhes',
        name: 'DetalhesEmpresa',
        component: () => import('@/views/empresas/EmpresaDetalhes.vue'),
        meta: { title: 'Detalhes da Empresa' }
      },
      {
        path: '/representantes',
        name: 'Representantes',
        component: () => import('@/views/representantes/RepresentantesList.vue'),
        meta: { title: 'Representantes' }
      },
      {
        path: '/representantes/novo',
        name: 'NovoRepresentante',
        component: () => import('@/views/representantes/RepresentanteForm.vue'),
        meta: { title: 'Novo Representante' }
      },
      {
        path: '/representantes/:id',
        name: 'EditarRepresentante',
        component: () => import('@/views/representantes/RepresentanteForm.vue'),
        meta: { title: 'Editar Representante' }
      },
      {
        path: '/documentos',
        name: 'Documentos',
        component: () => import('@/views/documentos/DocumentosList.vue'),
        meta: { title: 'Documentos' }
      },
      {
        path: '/recibos',
        name: 'Recibos',
        component: () => import('@/views/recibos/RecibosList.vue'),
        meta: { title: 'Recibos' }
      },
      {
        path: '/recibos/novo',
        name: 'NovoRecibo',
        component: () => import('@/views/recibos/ReciboForm.vue'),
        meta: { title: 'Novo Recibo' }
      },
      {
        path: '/recibos/:id',
        name: 'EditarRecibo',
        component: () => import('@/views/recibos/ReciboForm.vue'),
        meta: { title: 'Editar Recibo' }
      },
      {
        path: '/carnes',
        name: 'Carnes',
        component: () => import('@/views/carnes/CarnesList.vue'),
        meta: { title: 'Carnês' }
      },
      {
        path: '/carnes/novo',
        name: 'NovoCarne',
        component: () => import('@/views/carnes/CarneForm.vue'),
        meta: { title: 'Novo Carnê' }
      },
      {
        path: '/carnes/:id',
        name: 'EditarCarne',
        component: () => import('@/views/carnes/CarneForm.vue'),
        meta: { title: 'Editar Carnê' }
      },
      {
        path: '/procuracoes',
        name: 'Procuracoes',
        component: () => import('@/views/procuracoes/ProcuracoesList.vue'),
        meta: { title: 'Procurações' }
      },
      {
        path: '/procuracoes/nova',
        name: 'NovaProcuração',
        component: () => import('@/views/procuracoes/ProcuraçãoForm.vue'),
        meta: { title: 'Nova Procuração' }
      },
      {
        path: '/procuracoes/:id',
        name: 'EditarProcuração',
        component: () => import('@/views/procuracoes/ProcuraçãoForm.vue'),
        meta: { title: 'Editar Procuração' }
      },
      {
        path: '/dctfweb',
        name: 'Dctfweb',
        component: () => import('@/views/dctfweb/DctfwebList.vue'),
        meta: { title: 'DCTF Web' }
      },
      {
        path: '/dctfweb/novo',
        name: 'NovoDctfweb',
        component: () => import('@/views/dctfweb/DctfwebForm.vue'),
        meta: { title: 'Novo DCTF Web' }
      },
      {
        path: '/dctfweb/:id',
        name: 'EditarDctfweb',
        component: () => import('@/views/dctfweb/DctfwebForm.vue'),
        meta: { title: 'Editar DCTF Web' }
      },
      {
        path: '/notificacoes',
        name: 'Notificacoes',
        component: () => import('@/views/notificacoes/NotificacoesList.vue'),
        meta: { title: 'Notificações' }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/Login.vue'),
    meta: { title: 'Login', requiresAuth: false }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
    meta: { title: 'Página não encontrada' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, _from, next) => {
  // Atualizar título da página
  document.title = `${to.meta.title} - Sistema de Gestão Administrativa`
  next()
})

// Configurar guards de autenticação
setupAuthGuards(router)

export default router 